module.exports = __webpack_public_path__ + "img/ex-landing.6b016c34.jpg";